import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getDistanceObj } from '../Utils/googleUtil';
import { capitalize } from '../Utils/otherUtils';
import ExpandableContent from './ExpandableContent';
import CommuteAutoComplete from './CommuteAutoComplete';

const CommuteTime = (props) => {
  const [travel, setTravel] = useState();
  const [destination, setDestination] = useState();

  const {
    area: { name, coordinates },
    commuteDestination,
  } = props;

  const {
    language,
    text: { commuteTime: pageText },
  } = useSelector(state => state.Language);

  const fetchCommuteDurations = (place) => {
    getDistanceObj(
      `${coordinates.lat},${coordinates.long}`,
      place.place_id,
      language,
    ).then((resp) => {
      setTravel(resp);
      setDestination(place.description);
    }).catch((err) => {
      console.log(err);
    });
  };

  useEffect(() => {
    if (commuteDestination) {
      const fetchObject = {
        place_id: commuteDestination.placeId,
        description: commuteDestination.name,
      };
      fetchCommuteDurations(fetchObject);
    }
  }, []);

  return (
    travel ?
      <ExpandableContent
        id={pageText.heading}
        header={pageText.heading}
        hideDivider
      >
        <div className="main-text-content">
          <div className="commute-time">
            <p className="preamble">{pageText.preamble}</p>
            <div className="row collapse">
              <div className="columns medium-4 float-left">
                <CommuteAutoComplete
                  fieldLabel={pageText.whereTo}
                  initialPlaceName={commuteDestination.name}
                  fromQuery={commuteDestination.name}
                  coordinates={coordinates}
                  suggestionOnClick={place => fetchCommuteDurations(place)}
                />
              </div>
            </div>
            <div className="row collapse top-row">
              <div className="columns medium-10 float-left text-input-wrapper">
                <p className="f15 grey semi-bold result">{pageText.yourResult}</p>
                <p className="f15 semi-bold result">{`${pageText.fromPlaceholder + capitalize(name)} ${pageText.toPlaceholder} ${destination}`}</p>
              </div>
              <div className="columns medium-2">
                <p className="f18 grey semi-bold distance">{`${travel.distance}`}</p>
              </div>
            </div>
            <div className="row collapse commute-row">
              <div className="columns medium-3 small-12">
                <div className="commute-container">
                  <div className="inner car">
                    <p className="f18 grey semi-bold">{`${travel.car}`}</p>
                  </div>
                </div>
              </div>
              <div className="columns medium-3 small-12">
                <div className="commute-container">
                  <div className="inner public">
                    <p className="f18 grey semi-bold">{`${travel.transit}`}
                      <span className="asterisk">*</span>
                      <span className="tooltip">{pageText.publicTimeNote}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="columns medium-3 small-12">
                <div className="commute-container">
                  <div className="inner bike">
                    <p className="f18 grey semi-bold">{`${travel.bike}`}</p>
                  </div>
                </div>
              </div>
              <div className="columns medium-3 small-12">
                <div className="commute-container">
                  <div className="inner walk">
                    <p className="f18 grey semi-bold">{`${travel.walk}`}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row collapse">
              <div className="footnote-on-small">
                <span className="asterisk">*</span>
                {pageText.publicTimeNote}
              </div>
            </div>
          </div>
        </div>
      </ExpandableContent> : null);
};

export default CommuteTime;



// WEBPACK FOOTER //
// ./src/Components/CommuteTime.js